import React from "react";
import { Typography, Link } from "@mui/material";

export const getContent = (appCode, organisation = null) => {
    switch (appCode) {
        case "P-RMSD":
            return {
                image: "https://cdn.premierit.com/images/banners/portfolio/bnr-portfolio_001.png",
                title: "Appraisal",
                body: (
                    <Typography variant="body1">
                        Your Appraisal is a collection of evidence (activities /
                        resources) in an electronic format that showcases
                        learning over time. When you think about your ePortfolio
                        and the types of evidence that it contains, it is
                        important to think carefully about its purpose and
                        intended audience.
                    </Typography>
                ),
            };

        case "C-TMS":
            return {
                image: "https://cdn.premierit.com/images/banners/tms/bnr_tms_001.png",
                title: "Training",
                body: (
                    <Typography variant="body1">
                        Cortex training management solution (C-TMS) for the
                        administration, documentation, tracking, reporting and
                        delivery of educational courses, training programs, and
                        learning and development programs.
                    </Typography>
                ),
            };

        case "PORT":
            return {
                image: "https://cdn.premierit.com/images/banners/portfolio/bnr_port_001.png",
                title: "Portfolio",
                body: (
                    <Typography variant="body1">
                        Your ePortfolio is a collection of evidence (activities
                        / resources) in an electronic format that showcases
                        learning over time. When you think about your ePortfolio
                        and the types of evidence that it contains, it is
                        important to think carefully about its purpose and
                        intended audience.
                    </Typography>
                ),
            };

        case "Z-JP":
        case "P-JP":
            return {
                image: "https://cdn.premierit.com/images/banners/portfolio/bnr-portfolio_001.png",
                title: "Job Planner",
                body: (
                    <Typography variant="body1">
                        A job plan is a prospective, professional agreement
                        describing each employee’s duties, responsibilities,
                        accountabilities and objectives. It sets out how an
                        employee’s working time is spent on specified direct
                        clinical care (DCC), specified supporting professional
                        activities (SPA) and other activities, such as
                        additional NHS responsibilities and external duties.
                    </Typography>
                ),
            };

        case "C-LRS":
            return {
                image: "https://cdn.premierit.com/images/banners/lrs/bnr_clrs_001.png",
                title: "Welcome",
                body: (
                    <Typography variant="body1">
                        Centric is the gateway to your portfolio and eLearning
                        experience. Fully integrated with our CPD, Appraisal,
                        MSF and Job Planning software.
                    </Typography>
                ),
            };

        case "C-MSF":
        case "P-MSF":
            return {
                image: "https://cdn.premierit.com/images/banners/msf/bnr_pmsf_001.png",
                title: "360 Feedback",
                body: (
                    <Typography variant="body1">
                        Our 360 Degree Feedback tool is designed to give you
                        insight into other people’s perception of your
                        leadership abilities and behaviour. The process includes
                        getting confidential feedback from line managers, peers
                        and direct reports. This can be helpful to highlight
                        strengths or areas for development.
                    </Typography>
                ),
            };

        case "Z-RS":
            return {
                image: "https://cdn.premierit.com/images/banners/rs/bnr_zrs_001.png",
                title: "Rostering",
                body: (
                    <Typography variant="body1">
                        Our rostering solution is entirely suited to the health
                        and social care sector and requires no translational
                        approach. The system provides operational optimisation
                        of clinical safety measures such as skill mix and
                        competency assurance of staff rostering, job planning
                        and temporary staffing.
                    </Typography>
                ),
            };

        case "X-E360":
            return {
                image: "https://cdn.premierit.com/images/banners/external/x360/bnr_x360_001.png",
                title: "Edgecumbe Doctor 360",
                body: (
                    <Typography variant="body1">
                        360-degree feedback for individual doctors, GP Practices
                        and Trusts and Designated Bodies. Expert, cost-effective
                        feedback reports in record time.
                    </Typography>
                ),
            };

        default:
            switch (organisation) {
                case "027daf3e-3ef4-4452-b626-33adcf0f1e56":
                    return {
                        image: "https://cdn.premierit.com/images/banners/custom/bnr-cent_demo.png",
                        title: "Welcome",
                        body: (
                            <Typography variant="body1">
                                Centric is the gateway to your ePortfolio and
                                eLearning experience.
                                <br />
                                Fully integrated with our CPD, Job planning,
                                Appraisal, and 360 MSF software.
                            </Typography>
                        ),
                    };

                case "8098bf8b-f397-4acd-8f53-3afd36e5e475":
                    return {
                        image: "https://cdn.premierit.com/images/banners/centric/bnr-cent_001.png",
                        title: "Welcome",
                        body: (
                            <Typography variant="body1">
                                The CONNECT Learning Management System.
                                <br />
                                This e-learning system is going to be turned off
                                on the 30th of September 2025 as the contract
                                has come to an end.
                                <br />
                                Please speak to your administrator if you have
                                any further questions or alternatively you can
                                reach us at premierit.support@vitalhub.com.
                            </Typography>
                        ),
                    };

                default:
                    return {
                        image: "https://cdn.premierit.com/images/banners/centric/bnr-cent_001.png",
                        title: "Welcome",
                        body: (
                            <Typography variant="body1">
                                Centric is the gateway to your portfolio and
                                eLearning experience.
                                <br />
                                Fully integrated with our CPD, Job planning,
                                Appraisal, and 360 MSF software.
                            </Typography>
                        ),
                    };
            }
    }
};
